import { render, staticRenderFns } from "./studentStatisticsJournalZT.vue?vue&type=template&id=605391d4"
import script from "./studentStatisticsJournalZT.vue?vue&type=script&lang=js"
export * from "./studentStatisticsJournalZT.vue?vue&type=script&lang=js"
import style0 from "./studentStatisticsJournalZT.vue?vue&type=style&index=0&id=605391d4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports